import { ActionAny, createActions } from 'src/utils/createActions';
import { DemoPageParams } from 'src/react/demoPage/state/DemoPageParams';
import { DemoPageData } from 'src/react/demoPage/state/DemoPageState';

export type DemoSearchActions =
    ActionAny<DemoPageParams, DemoPageData | null>;
export const DEMO_SEARCH_ACTIONS =
    createActions<DemoPageParams, DemoPageData | null>('DEMO_SEARCH');
